import { render, staticRenderFns } from "./DashIntake.vue?vue&type=template&id=3cb497ae&scoped=true&"
import script from "./DashIntake.vue?vue&type=script&lang=js&"
export * from "./DashIntake.vue?vue&type=script&lang=js&"
import style0 from "./DashIntake.vue?vue&type=style&index=0&id=3cb497ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb497ae",
  null
  
)

export default component.exports